import React, { useState, useEffect } from 'react';
import './Timer.scss';

const Timer = () => {
  const [time, setTime] = useState(300); // 5 minutes in seconds

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prevTime => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60).toString().padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  return (
    <div className="timer">
      <div className="text">Remaining Time:</div>
      <div className="countdown">{formatTime(time)}</div>
    </div>
  );
};

export default Timer;
